import a from "./_ListCache.js";
var t = a;
function e() {
  this.__data__ = new t(), this.size = 0;
}
var i = e;
export {
  i as default
};
//# sourceMappingURL=_stackClear.js.map
